export default __webpack_public_path__ + "static/media/placeholder_business03-es-mobile.8f66d144.png";